import { IColumns } from '../../../components/Table'
import { getReadableUserType } from '../../../constants/userPermissions'

export type SettingsUsersColumnsType = 'id' | 'email' | 'userName' | 'userRole' | 'createdAt' | 'actions'

export const columns: IColumns<SettingsUsersColumnsType>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'email',
    label: 'EMAIL',
  },
  {
    id: 'userName',
    label: 'USER NAME',
  },
  {
    id: 'userRole',
    label: 'USER ROLE',
    format: (value) => getReadableUserType(value as string),
  },
  {
    id: 'createdAt',
    label: 'CREATED AT',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
  {
    id: 'actions',
    label: 'ACTIONS',
  },
]
